import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Sparkles } from 'lucide-react';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import PackagesAdmin from './Packages';

export default function BudgetPackages() {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <Card className="bg-white border border-slate-200 shadow-sm rounded-2xl">
        <CardContent className="p-8 space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-2xl bg-emerald-50 flex items-center justify-center">
              <Sparkles size={22} className="text-emerald-700" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>Budget Packages</h1>
              <p className="text-sm text-slate-500">Manage Budget access, limits and premium flags from the existing package editor.</p>
            </div>
          </div>
          <div className="rounded-2xl border border-slate-100 bg-slate-50 p-4 text-sm text-slate-600">
            Budget packages use the same package records as the main subscription system, so edits here update the same plan data used across Jjuma Pay.
          </div>
          <div className="flex flex-wrap gap-2">
            <Button className="bg-emerald-700 hover:bg-emerald-800 text-white" onClick={() => navigate('/admin/packages')}>
              <ArrowLeft size={14} className="mr-1.5" /> Open Full Package Manager
            </Button>
          </div>
        </CardContent>
      </Card>

      <PackagesAdmin />
    </div>
  );
}
